const experiences = [
  {
    id: "dayforce-software-developer",
    company: "Dayforce (formerly Ceridian)",
    iconFileName: "dayforce-icon.png",
    imageFileName: "",
    location: "Toronto, Ontario",
    title: "Software Developer III",
    date: "July 2022 - Present",
    isCurrentPosition: true,
    description: "",
    extras: [
      {
        title: "Responsibilities",
        cardLayout: false,
        items: [],
      },
      {
        title: "Projects/Tasks",
        cardLayout: true,
        items: [],
      },
    ],
  },
  {
    id: "tripspark-full-stack-developer",
    company: "TripSpark Technologies",
    iconFileName: "tripspark-icon.png",
    imageFileName: "tripspark.png",
    location: "Mississauga, Ontario",
    title: "Full Stack Software Developer",
    date: "July 2017 - July 2022",
    isCurrentPosition: false,
    description: `Developed, maintained and designed features and improvemnts for a transportation software. Worked full-stack on the all-in-one solution which can
                      schedule, find efficient routes and manage entities for transportation sites. Led numerous projects to implement new features, as well as optimize
                      and code refactor the existing large code base.`,
    extras: [
      {
        title: "Responsibilities",
        cardLayout: false,
        items: [
          {
            text:
              "Leveraged the ability to deeply understand a large code base to refactor and optimize existing code for performance, readability, understandability, and maintainability",
          },
          {
            text: "Trained, mentored and supported junior developers via knowledge transfer and code guidance",
          },
          {
            text:
              "Participated in design/architecture meetings, peer code reviews, and unit tests to ensure important deadlines are met with high quality code",
          },
          {
            text: "Designed and developed applications using both microservices and monolithic architectures",
          },
          {
            text:
              "Completed over 98% of assigned sprint tasks while maintaining high quality code by only generating a major-plus bug for every 500 hours of development ",
          },
        ],
      },
      {
        title: "Projects/Tasks",
        cardLayout: true,
        items: [
          {
            title: "Next-Gen Product",
            style: "fas",
            icon: "bus",
            text:
              "Developed the next generation of products to better enable transportation using a microservices architecture using ASP.NET Core and Vue.js",
          },
          {
            title: "Product UI & UX Redesign",
            style: "far",
            icon: "window-restore",
            text: "Assisted in the redesign of the user interface to improve the UI and UX design",
          },
          {
            title: "Self-serve Password Reset",
            style: "fas",
            icon: "key",
            text: "Ability for users to reset their passwords with a temporary password sent via email",
          },
          {
            title: "REST APIs",
            style: "fas",
            icon: "wifi",
            text: "Designed and implemented many APIs that allowed external vendors to import and export trip data",
          },
          {
            title: "Generic Packages Repo",
            style: "fas",
            icon: "database",
            text: "Created and maintained generic internal NuGet and npm packages used across multiple products",
          },
        ],
      },
    ],
  },
  {
    id: "peel-region-infrastructure-analyst",
    company: "Regional Municipality of Peel",
    iconFileName: "peelregion-icon.png",
    imageFileName: "peelregion.png",
    location: "Brampton, Ontario",
    title: "Infrastructure Analyst",
    date: "May 2013 - December 2016 (Co-op)",
    isCurrentPosition: false,
    description: `As an Infrastructure Analyst and Network Administrator at the Region of Peel, my role included both hardware and software perspectives. 
                      Within the Infrastructure category, it included server maintenance (virtual and physical), Brocade switching protocol, Avaya telephony 
                      configurations and monthly server patches. As a Network Administrator, I was responsible for domain accounts within the network. This 
                      includes managing user, group and computer accounts on Active Directory and the Exchange Management Console. In addition, the deployment 
                      of SafeNet tokens to end users for remote access were provided. Blackberry phone management were also monitored for end users. With the 
                      upgrade to Microsoft Office's newest product, Office 365, I assisted with the deployment of licenses and migration.`,
    extras: [
      {
        title: "Projects",
        cardLayout: true,
        items: [
          {
            title: "Office 365 Accounts Migration",
            style: "fas",
            icon: "user",
            text: "Assisted in the migration of hundreds of users, distribution lists and shared mailboxes",
          },
          {
            title: "Server Relocation",
            style: "fas",
            icon: "server",
            text:
              "Assisted and organized in a complete shutdown in servers within a data centre in preparation for the move",
          },
        ],
      },
      {
        title: "Scripts",
        cardLayout: true,
        items: [
          {
            title: "Account Expiry Notification",
            style: "fas",
            icon: "user",
            text: `Notify a user's manager when their account is about to expiry (30 days, 15 days and 1 day before)`,
          },
          {
            title: "SMTP Removal",
            style: "fas",
            icon: "at",
            text: "Removal of non-accepted Office 365 SMTP addresses associated with their Active Directory account",
          },
          {
            title: "Office 365 License Change",
            style: "fas",
            icon: "id-badge",
            text: "Add and remove correct Office 365 licenses for all users",
          },
          {
            title: "Distribution List Migration",
            style: "fas",
            icon: "clipboard-list",
            text: "Creation and migration of distribution lists from Exchange 2007 to Office 365",
          },
        ],
      },
    ],
  },
];

export default experiences;
